// If a given line property is an object that contains 'label' & 'value' properties,
// then this function drops the 'label' property and assigns the value of 'value'
// directly to said property.
// i.e. { account: { label: 'Cameraman', value: 543 } -----> { account: 543 }
export function cleanupLines (lines) {
  return lines.map(l => {
    let newForm = {}
    let form
    if (l.hasOwnProperty('form')) {
      form = l.form
    } else {
      form = l
    }
    Object.keys(form).forEach(f => {
      if (form[f] && form[f].hasOwnProperty('value')) {
        newForm[f] = form[f].value
      } else {
        newForm[f] = form[f]
      }
      newForm['line_number'] = l.line_number
    })
    return { num: l.line_number, form: newForm }
  })
}



// WEBPACK FOOTER //
// ./src/utils/helpers/CheckDistributionLines.js